/* eslint-disable react/no-array-index-key */
import { css, jsx } from '@emotion/core';
import { Icon } from 'antd';
import Router from 'next/router';
import React, { useState } from 'react';

import EditSavedSearch from '@/src/compliance/components/CompliAssist/SavedSearches/SavedSearchRow/EditSavedSearch';
import Button from '@/src/shared/components/Button';
import Card from '@/src/shared/components/Card';
import Heading from '@/src/shared/components/Heading';
import CustomIcon from '@/src/shared/components/Icon';
import { bp, colors } from '@/styles';

const styles = {
  actionsRow: css`
    padding-top: 8px;
    margin-top: auto;
  `,
  actionsTitle: css`
    padding-bottom: 4px;
  `,
  cardContainer: css`
    width: 100%;
    margin: 10px;
    display: flex;
    flex-direction: column;
    padding: 34px 16px 28px;
    @media ${bp.lg} {
      margin-bottom: 0px;
      max-width: 368px;
      width: 32%;
    }
    @media ${bp.xl} {
      padding: 28px;
    }
  `,
  icon: css`
    color: ${colors.secondaryBlue};
    height: 56px;
    width: 56px;
    margin-right: 12px;
  `,
  cardTitleContainer: css`
    display: flex;
    margin-bottom: 14px;
    align-items: center;
  `,
  infoSectionContainer: css`
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    h5 {
      margin-bottom: 0;
    }
  `,
  infoSectionTags: (keepTagsInRow = false) => css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: ${keepTagsInRow ? 'row' : 'column'};
  `,
  chartButtonContainer: css`
    display: flex;
  `,
  chartButton: css`
    align-items: center;
    display: flex;
    color: ${colors.secondaryBlue};
    padding: 0px 8px !important;
    @media ${bp.xl} {
      padding: 0px 8px !important;
    }
    span {
      margin-left: 2px !important;
      @media ${bp.xl} {
        margin-left: 4px !important;
      }
    }
  `,
  chartIcon: css`
    display: flex !important;
    width: 12px;
    height: 12px;
    svg {
      font-size: 10px !important;
    }
  `,
};

const InfoSection = ({ title, options, keepTagsInRow = false, maxOptions = 10, ...props }) => {
  let opts = options;
  let more = 0;
  if (Array.isArray(options) && options.length > maxOptions) {
    more = options.length - maxOptions;
    opts = options.slice(0, maxOptions);
  }

  return (
    <div css={styles.infoSectionContainer} {...props}>
      <Heading weight="bolder" theme="gray" type="5">
        {title}
      </Heading>
      <div css={styles.infoSectionTags(keepTagsInRow)}>
        {Array.isArray(opts) && opts.length > 1 ? (
          opts.map((option, index) => {
            return (
              <Heading
                type="4"
                theme="primaryBlue"
                weight="bolder"
                key={`${title}_${option}_${index}`}
              >
                {option}
                {index + 1 < opts.length && <span>,&nbsp;</span>}
              </Heading>
            );
          })
        ) : (
          <Heading type="4" theme="primaryBlue" weight="bolder">
            {opts}
          </Heading>
        )}

        {more > 0 ? (
          <Heading weight="bolder" type="4" theme="primaryBlue">
            , +{more} more
          </Heading>
        ) : null}
      </div>
    </div>
  );
};

const ComplianceChart = ({ data, iconName }) => {
  const [isModalVisible, setModalVisible] = useState(false);

  const {
    SearchDescription,
    SearchId,
    FieldOptions: { Categories, Charts, States, SearchText },
  } = data;

  const handleSearch = () => {
    Router.push(`/compliance/compliassist?searchId=${SearchId}`);
  };
  return (
    <>
      <EditSavedSearch
        visible={isModalVisible}
        closeModal={() => setModalVisible(false)}
        data={data}
      />
      <Card css={styles.cardContainer}>
        <div css={styles.cardTitleContainer}>
          <CustomIcon css={styles.icon} ant={false} name={iconName} />
          <InfoSection
            title="Search Description"
            options={SearchDescription}
            css={css`
              margin-bottom: 0;
            `}
          />
        </div>

        <div>
          <InfoSection
            title="Charts"
            options={Charts.length > 0 ? Charts.map(c => c.ChartDescription) : 'All Charts'}
            maxOptions={5}
          />
          <InfoSection
            title="States"
            options={States.length > 0 ? States.map(s => s.StateDescription) : 'All States'}
            maxOptions={5}
            keepTagsInRow
          />
          {Categories.length > 0 && (
            <InfoSection title="Category" options={Categories.map(c => c.CategoryDescription)} />
          )}
          {SearchText && (
            <InfoSection
              title="Search Text"
              options={SearchText}
              css={css`
                margin-bottom: 0;
              `}
            />
          )}
        </div>

        <div css={styles.actionsRow}>
          <Heading type="6" theme="gray" weight="bolder" css={styles.actionsTitle}>
            ACTIONS
          </Heading>
          <div css={styles.chartButtonContainer}>
            <Button
              css={styles.chartButton}
              inGroup
              theme="transparent"
              size="small"
              onClick={handleSearch}
            >
              <Icon css={styles.chartIcon} type="eye" theme="filled" />
              View
            </Button>
            {/* <Button css={styles.chartButton} inGroup theme="transparent" size="small">
              <Icon css={styles.chartIcon} type="printer" theme="filled" />
              Print
            </Button> */}
            <Button
              css={styles.chartButton}
              inGroup
              theme="transparent"
              size="small"
              onClick={() => setModalVisible(true)}
            >
              <Icon css={styles.chartIcon} type="edit" theme="filled" />
              Edit
            </Button>
            {/* <Button css={styles.chartButton} inGroup theme="transparent" size="small">
              <Icon css={styles.chartIcon} type="file-excel" theme="filled" />
              Excel
            </Button>
            <Button css={styles.chartButton} inGroup theme="transparent" size="small">
              <Icon css={styles.chartIcon} type="file-pdf" theme="filled" />
              PDF
            </Button> */}
          </div>
        </div>
      </Card>
    </>
  );
};

export default ComplianceChart;
